import React from 'react'
import { getListOfDaysInMonth, wipeValueIfDayLargerThanMonthsAllowed } from "@utils/helpers/dateHelper";
import { DatePart } from "./datePart";

export const DateDay = ({name, day, month, year, ariaLabel, setFieldValue, handleChange, handleBlur, errors, touched}) => {
  const activeDays = getListOfDaysInMonth(month, year);
  wipeValueIfDayLargerThanMonthsAllowed(day, month, year,
    () => setFieldValue(`${name}.day`, ""));
  
  return (
    <DatePart 
      name={name}
      dayMonthOrYear="day"
      ariaLabel={ariaLabel}
      value={day}
      handleChange={handleChange}
      handleBlur={handleBlur}
      errors={errors}
      touched={touched}
      options={activeDays}
    />
  )
};

